import { ComponentPropsWithoutRef } from 'react';

export function Ul(props: ComponentPropsWithoutRef<'ul'>) {
  return <ul {...props} className="list-outside list-disc pl-24" />;
}
